import { LoadingSpinnerIcon } from '@mgmresorts/wcl-lab';
import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';

import { KnownError } from '../../api/errors';
import { linkPartnerRequest } from '../../api/fetch/link-partner';
import { marriottTokenRequest, AuthToken } from '../../api/fetch/marriott-token';
import { useAppRedirect } from '../../hooks/useAppRedirect';
import { IDENTITY_WIDGET_BASEPATH, IDENTITY_WIDGET_PATHS } from '../../utils/constants';
import { getPersistedParameters } from '../../utils/persistParameterContext';
import { getOrigin } from '../../utils/url';

export default function MarriottBonvoyLinkPage() {
  const [authToken, setAuthToken] = useState<AuthToken>();
  const redirectToApp = useAppRedirect();

  const redirectWithErrorCode = useCallback(
    (error: unknown) => {
      let linkingResponseCode = 'other';

      if (error instanceof KnownError) {
        linkingResponseCode = (error as KnownError).code;
      }

      redirectToApp({ linkingResponseCode });
    },
    [redirectToApp],
  );

  useLayoutEffect(() => {
    const params = getPersistedParameters();
    const fetchData = async () => {
      try {
        const _token = await marriottTokenRequest({
          redirect_uri: `${getOrigin().replace('www.', '')}${IDENTITY_WIDGET_BASEPATH}${
            IDENTITY_WIDGET_PATHS.MarriottBonvoyPartnerLink
          }`,
          code: (params.code ?? '') as string,
          grant_type: 'authorization_code',
          state: (params.state ?? '') as string,
          scope: 'openid',
        });

        setAuthToken(_token);
      } catch (error: unknown) {
        redirectWithErrorCode(error);
      }
    };

    params.code && fetchData();
  }, [redirectWithErrorCode]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await linkPartnerRequest({
          partner: 'MARRIOTT',
          partnerAccessToken: authToken?.access_token ?? '',
          partnerIdToken: authToken?.id_token ?? '',
        });

        redirectToApp({ linkingResponseCode: 'success' });
      } catch (error: unknown) {
        redirectWithErrorCode(error);
      }
    };

    authToken && fetchData();
  }, [authToken, redirectToApp, redirectWithErrorCode]);

  return <LoadingSpinnerIcon size='48' testId='route-/external/authentication/east' />;
}
